<template>
  <div class="switch_wrap">
    <Header
      :routerarr="routerArr"
      v-if="reg([
        '/switch/test/preview',
        '/switch/test/stupreview',
        '/switch/test/testPaper',
        '/switch/examination/detailsPage',
         '/switch/test/successNew',
         '/switch/test/success',
         ])"
    ></Header>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
  import Header from '../header'
  import * as api from '../../../../api/courseApi'
  import * as HNstatisticsApi from '@/api/HNstatisticsApi'
  export default {
    name: "switchpage",
    data(){
      return{
        courseId: this.$route.query.id,
        classId: this.$route.query.classId,
        pageType: 0,
        routerArr: [],
        userType: sessionStorage.getItem('userType'),
        productFlag: sessionStorage.getItem('productFlag'),
        //
        timer: null,
      }
    },
    watch: {
      '$route' (to) {
        this.getPageType(to);
     }
    },
    components:{
      Header
    },
    mounted() {
      this.getRouterArr();
      this.pageLearningTime();
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    },
    destroyed() {
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    },
    methods:{
      // 记录用户在课程页面停留多长时间
      beforeunloadHandler(e){
        let time = new Date().getTime();
        if (this.$route.meta.time &&  time - this.$route.meta.time > 5*1000) {
          let data = {
            ext: '测试',
            "endTime": time,
            "routeUrl": process.env.BASE_API + this.$route.fullPath,
            "startTime": Number(this.$route.meta.time),
            "time": Math.ceil((time - this.$route.meta.time) / 1000),
            "userId": window.sessionStorage.getItem('userId')
          }
          api.endVideo(data).then(()=>{})
        }
      },
    	reg(list){
        let arr = []
        list.forEach((v,i)=>{
          arr.push(v==this.$route.path)
        })
        return !arr.includes(true)
      },
      getRouterArr(){
        if(sessionStorage.getItem('isPreview')=='false'){
          if(this.userType==0||this.userType==1){
            if(this.productFlag==1){
              this.routerArr = [
                { name: "课件", path: "/switch/courseware" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "考勤", path: "/switch/workattendance" },//考勤
                { name: "测验", path: "/switch/test" },//课件测验
                { name: "考试", path: "/switch/examination" },//考试
                { name: "成绩", path: "/switch/achievement" },//成绩
                { name: "统计", path: "/switch/statistics" },//统计
                { name: "通知", path: "/switch/notice" },//通知
                { name: "设置", path: "/switch/seachsetup" },//设置
              ]
            }else if(this.productFlag==2){
              this.routerArr = [
                { name: "任务", path: "/switch/courseware" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "考勤", path: "/switch/workattendance" },//考勤
                { name: "统计", path: "/switch/statistics" },//统计
                { name: "通知", path: "/switch/notice" },//通知
                { name: "设置", path: "/switch/seachsetup" },//设置
              ]
            }else if(this.productFlag==3){
              this.routerArr = [
                { name: "任务", path: "/switch/courseware" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "考勤", path: "/switch/workattendance" },//考勤
                { name: "统计", path: "/switch/statistics" },//统计
                { name: "通知", path: "/switch/notice" },//通知
                { name: "设置", path: "/switch/seachsetup" },//设置
              ]
            }else if(this.productFlag==4){
              this.routerArr = [
                { name: "任务", path: "/switch/studentTask" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "通知", path: "/switch/notice" },//通知
              ]
            }else if(this.productFlag==7){
              this.routerArr = [
                { name: "任务", path: "/switch/training2/courseDetail" },//任务
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "考勤", path: "/switch/workattendance" },//考勤
                { name: "统计", path: "/switch/statistics" },//统计
                { name: "通知", path: "/switch/notice" },//通知
                { name: "设置", path: "/switch/seachsetup" },//设置
              ]
            }else{
              this.routerArr = [
                { name: "课件", path: "/switch/courseware" },//课件
              ]
            }
          }else{
            if(this.productFlag==1){
              this.routerArr = [
                { name: "课件", path: "/switch/courseware" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "考勤", path: "/switch/workattendance" },//考勤
                { name: "测验", path: "/switch/test" },//课件测验
                { name: "考试", path: "/switch/examination" },//考试
                { name: "成绩", path: "/switch/achievement" },//成绩
                { name: "统计", path: "/switch/statistics" },//统计
                { name: "通知", path: "/switch/notice" },//通知
              ]
            }else if(this.productFlag==2){
              this.routerArr = [
                { name: "任务", path: "/switch/courseware" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "考勤", path: "/switch/workattendance" },//考勤
                { name: "统计", path: "/switch/statistics" },//统计
                { name: "通知", path: "/switch/notice" },//通知
              ]
            }else if(this.productFlag==3){
              this.routerArr = [
                { name: "任务", path: "/switch/courseware" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "考勤", path: "/switch/workattendance" },//考勤
                { name: "小组", path: "/switch/group" },//小组
                { name: "统计", path: "/switch/statistics" },//统计
                { name: "通知", path: "/switch/notice" },//通知
              ]
            }else if(this.productFlag==4){
              this.routerArr = [
                { name: "任务", path: "/switch/studentTask" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "小组", path: "/switch/group" },//小组
                { name: "通知", path: "/switch/notice" },//通知
              ]
            }else if(this.productFlag==7){
              this.routerArr = [
                { name: "任务", path: "/switch/training2/courseDetail" },//课件
                { name: "讨论", path: "/switch/discuss" },//讨论
                { name: "笔记", path: "/switch/note" },//笔记
                { name: "考勤", path: "/switch/workattendance" },//考勤
                { name: "小组", path: "/switch/group" },//小组
                { name: "统计", path: "/switch/statistics" },//统计
                { name: "通知", path: "/switch/notice" },//通知
              ]
            }else{
              this.routerArr = [
                { name: "课件", path: "/switch/courseware" },//课件
              ]
            }
          }
        }else{
          this.routerArr = [ { name: "课件", path: "/switch/courseware/preview" } ]
          // if(this.productFlag==4){
          //   this.routerArr = [ { name: "课件", path: "/switch/studentTask" } ]//任务
          // }else{
          //   this.routerArr = [ { name: "课件", path: "/switch/courseware" } ]//课件
          // }
        }
        // let query = {
        //   id: this.$route.query.id,
        //   classId: this.$route.query.classId,
        //   className: this.$route.query.className,
        // }
        // if(this.productFlag==4){
        //   this.$router.push({
        //     path:'/switch/studentTask',
        //     query: query
        //   })
        // }else{
        //   if(str!='test' || str!='discuss'){
        //     if(sessionStorage.getItem('isPreview')=='true'){
        //       this.$router.push({
        //         path:'/switch/courseware/preview',
        //         query: {
        //           id: this.$route.query.id
        //         }
        //       })
        //     }else{
        //       this.$router.push({
        //         path:'/switch/courseware/courseDetail',
        //         query: query
        //       })
        //     }
        //   }
        // }
        // this.$ajax.get("/api-course/course/" + this.$route.query.id).then(rs=>{
        //   if(rs.data.code==0){
        //     let courseType = rs.data.data.courseType;
        //     let type = rs.data.data.type;
        //     localStorage.setItem('courseType', rs.data.data.type)

        //   }
        // })
        console.log(this.routerArr)
      },
      // 获取页面中间键
      // pageType,
      // 页面类型 0:课程 1:实训 2:资源 3:测评 4:讨论 5:笔记 6:通知 7:作业 8:学员 9:统计 10:设置 11:综合实训2.0
      getPageType(to){
        this.pageType = '';
        if (to.path === '/switch/courseware/courseDetail'){  // 课程
          this.pageType = 0
        }else
        if (to.path === '/switch/discuss/all'){  // 讨论
          this.pageType = 4
        }else
        if (to.path === '/switch/test' || to.path === '/switch/examination'){  // 测验
          this.pageType = 3
        }else
        if (to.path === '/switch/statistics/comprehensiveTraining'){  // 统计
          this.pageType = 9
        }else
        if (to.path === '/switch/note'){  // 笔记
          this.pageType = 5
        }else
        if (to.path === '/switch/notice'){  // 通知
          this.pageType = 6
        }else
        if (to.path === '/switch/workattendance'){  // 考勤
          this.pageType = ''
        }else
        if (to.path === '/switch/seachsetup'){  // 设置
          this.pageType = 10
        }else
        if (to.path === '/switch/training2/courseDetail'){  // 设置
          this.pageType = 11
        }
        console.log(this.pageType)
      },
      // 保存页面停留时长
      pageLearningTime(){
        this.timer = setInterval(()=>{
          let params = {
            courseId: this.courseId,
            classId: this.classId,
            pageType: this.pageType,   // 页面类型 0:课程 1:实训 2:资源 3:测评 4:讨论 5:笔记 6:通知 7:作业 8:学员 9:统计 10:设置
            prodType: 0,   // 产品类型 0：教学 1：真实任务
            time: 15 ,  // 学习时间单位秒
          }
          HNstatisticsApi.pageLearningTime(params)
        }, 15000)
      },
    },
    beforeDestroy(){
      clearInterval(this.timer);
      this.timer = null;
    },
  }
</script>

<style lang="scss" scoped>
  .switch_wrap{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    main{
      width: 100%;
      flex: 1;
      overflow: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/switchpage.vue